// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3bAyF","selected":"Chip_selected__1ANoK"};